import { Component } from '../../../concepts/objects';
import { lockedLayout } from '../../canvas/properties/LockablePropertyStripLayout';
import { PropertyFacade } from '../../canvas/properties/PropertyFacade';
import { PropertyStripLayout } from '../../canvas/properties/PropertyStripLayout';
import { lockAndMoreLayout } from '../../canvas/properties/TextPropertyStripParts';
import { Frame } from './Frame';
import { frameRemove } from './FrameCommands';

const determineAddonType = (a: PropertyFacade<Frame>) => {
    const addons = a.map(x => x.addon()).filter(x => !!x);
    if (addons.length <= 0) return null;
    const typeDesc = Component.describe(addons[0]);
    if (addons.every(x => x.is(typeDesc.type))) return typeDesc;
    return null;
};

export const framePropertyLayout = PropertyStripLayout<Frame>((d, s, o, w, a) => {
    const locked = !!a.get('locked', { ifVarying: true });

    // From
    const baseLayout = [
        w.createColorSelector({
            allowNull: true,
            autoSelect: true,
            groups: true,
            value: a.get('background'),
            text: 'Background Color',
            onSelect() {
                o.update(u => {
                    u.rolling(a.keyFor('background'));
                    a.set('background', this.value!);
                });
            }
        }),
        // w.createButton({
        //     image: 'deqo://icons/hero/tag',
        //     text: a.get('titleVisible', { useFirstIfVarying: true }) ? 'Hide Title' : 'Show Title',
        //     onAction() {
        //         const newValue = !a.get('titleVisible', { useFirstIfVarying: true });
        //         o.update(u => {
        //             u.rolling(a.keyFor('titleVisible'));
        //             a.set('titleVisible', newValue);
        //         });
        //         this.update({ text: newValue ? 'Hide Title' : 'Show Title' });
        //     }
        // }),
        w.createDivide(),
    ];

    const deleteLayout = [
        w.createButton({
            text: 'Remove Frame',
            image: 'deqo://icons/d2/frame-delete',
            onAction() {
                d(frameRemove, [a.map(x => x.id)]);
            }
        })
    ];

    const addonType = determineAddonType(a);
    const addonLayout = !!addonType?.propertyLayout
        ? [...addonType.propertyLayout(d, s, o, w, a.readapt(x => x.addon())), w.createDivide()]
        : [];

    if (locked) {
        return [
            ...(addonType?.name === 'ActivityFrameAddon' ? addonLayout : []),
            ...lockedLayout(d, s, o, w, a),
        ];
    }
    else {
        return [
            ...baseLayout,
            ...addonLayout,
            ...deleteLayout,
            ...lockAndMoreLayout(d, s, o, w, a),
        ];
    }
});
